var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"xm-content"},[_c('router-view')],1),_c('div',{staticClass:"go-home",on:{"click":_vm.handleGoHome}},[_vm._v("\n    工作台\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }